import { useContext } from 'react';
import { StoreContext } from './ProviderStore';
import { UCFStore } from 'ucf-lib';

export const useStore = (): UCFStore => useContext(StoreContext);
